export default __webpack_public_path__ + "logo-dark-small.871f62fb25dff8895d6ce6731c4c718b.svg";